/*
    A model used to embed GTM product, inside datalayer.
    It also deals with NG scope object parsing 
*/
webClient.factory('gtmProduct', ['$location', '$window', 'scopeParser', function ($location, $window, scopeParser) {

    function gtmProduct() { }

    function MD5(s) { function L(k, d) { return (k << d) | (k >>> (32 - d)) } function K(G, k) { var I, d, F, H, x; F = (G & 2147483648); H = (k & 2147483648); I = (G & 1073741824); d = (k & 1073741824); x = (G & 1073741823) + (k & 1073741823); if (I & d) { return (x ^ 2147483648 ^ F ^ H) } if (I | d) { if (x & 1073741824) { return (x ^ 3221225472 ^ F ^ H) } else { return (x ^ 1073741824 ^ F ^ H) } } else { return (x ^ F ^ H) } } function r(d, F, k) { return (d & F) | ((~d) & k) } function q(d, F, k) { return (d & k) | (F & (~k)) } function p(d, F, k) { return (d ^ F ^ k) } function n(d, F, k) { return (F ^ (d | (~k))) } function u(G, F, aa, Z, k, H, I) { G = K(G, K(K(r(F, aa, Z), k), I)); return K(L(G, H), F) } function f(G, F, aa, Z, k, H, I) { G = K(G, K(K(q(F, aa, Z), k), I)); return K(L(G, H), F) } function D(G, F, aa, Z, k, H, I) { G = K(G, K(K(p(F, aa, Z), k), I)); return K(L(G, H), F) } function t(G, F, aa, Z, k, H, I) { G = K(G, K(K(n(F, aa, Z), k), I)); return K(L(G, H), F) } function e(G) { var Z; var F = G.length; var x = F + 8; var k = (x - (x % 64)) / 64; var I = (k + 1) * 16; var aa = Array(I - 1); var d = 0; var H = 0; while (H < F) { Z = (H - (H % 4)) / 4; d = (H % 4) * 8; aa[Z] = (aa[Z] | (G.charCodeAt(H) << d)); H++ } Z = (H - (H % 4)) / 4; d = (H % 4) * 8; aa[Z] = aa[Z] | (128 << d); aa[I - 2] = F << 3; aa[I - 1] = F >>> 29; return aa } function B(x) { var k = "", F = "", G, d; for (d = 0; d <= 3; d++) { G = (x >>> (d * 8)) & 255; F = "0" + G.toString(16); k = k + F.substr(F.length - 2, 2) } return k } function J(k) { k = k.replace(/rn/g, "n"); var d = ""; for (var F = 0; F < k.length; F++) { var x = k.charCodeAt(F); if (x < 128) { d += String.fromCharCode(x) } else { if ((x > 127) && (x < 2048)) { d += String.fromCharCode((x >> 6) | 192); d += String.fromCharCode((x & 63) | 128) } else { d += String.fromCharCode((x >> 12) | 224); d += String.fromCharCode(((x >> 6) & 63) | 128); d += String.fromCharCode((x & 63) | 128) } } } return d } var C = Array(); var P, h, E, v, g, Y, X, W, V; var S = 7, Q = 12, N = 17, M = 22; var A = 5, z = 9, y = 14, w = 20; var o = 4, m = 11, l = 16, j = 23; var U = 6, T = 10, R = 15, O = 21; s = J(s); C = e(s); Y = 1732584193; X = 4023233417; W = 2562383102; V = 271733878; for (P = 0; P < C.length; P += 16) { h = Y; E = X; v = W; g = V; Y = u(Y, X, W, V, C[P + 0], S, 3614090360); V = u(V, Y, X, W, C[P + 1], Q, 3905402710); W = u(W, V, Y, X, C[P + 2], N, 606105819); X = u(X, W, V, Y, C[P + 3], M, 3250441966); Y = u(Y, X, W, V, C[P + 4], S, 4118548399); V = u(V, Y, X, W, C[P + 5], Q, 1200080426); W = u(W, V, Y, X, C[P + 6], N, 2821735955); X = u(X, W, V, Y, C[P + 7], M, 4249261313); Y = u(Y, X, W, V, C[P + 8], S, 1770035416); V = u(V, Y, X, W, C[P + 9], Q, 2336552879); W = u(W, V, Y, X, C[P + 10], N, 4294925233); X = u(X, W, V, Y, C[P + 11], M, 2304563134); Y = u(Y, X, W, V, C[P + 12], S, 1804603682); V = u(V, Y, X, W, C[P + 13], Q, 4254626195); W = u(W, V, Y, X, C[P + 14], N, 2792965006); X = u(X, W, V, Y, C[P + 15], M, 1236535329); Y = f(Y, X, W, V, C[P + 1], A, 4129170786); V = f(V, Y, X, W, C[P + 6], z, 3225465664); W = f(W, V, Y, X, C[P + 11], y, 643717713); X = f(X, W, V, Y, C[P + 0], w, 3921069994); Y = f(Y, X, W, V, C[P + 5], A, 3593408605); V = f(V, Y, X, W, C[P + 10], z, 38016083); W = f(W, V, Y, X, C[P + 15], y, 3634488961); X = f(X, W, V, Y, C[P + 4], w, 3889429448); Y = f(Y, X, W, V, C[P + 9], A, 568446438); V = f(V, Y, X, W, C[P + 14], z, 3275163606); W = f(W, V, Y, X, C[P + 3], y, 4107603335); X = f(X, W, V, Y, C[P + 8], w, 1163531501); Y = f(Y, X, W, V, C[P + 13], A, 2850285829); V = f(V, Y, X, W, C[P + 2], z, 4243563512); W = f(W, V, Y, X, C[P + 7], y, 1735328473); X = f(X, W, V, Y, C[P + 12], w, 2368359562); Y = D(Y, X, W, V, C[P + 5], o, 4294588738); V = D(V, Y, X, W, C[P + 8], m, 2272392833); W = D(W, V, Y, X, C[P + 11], l, 1839030562); X = D(X, W, V, Y, C[P + 14], j, 4259657740); Y = D(Y, X, W, V, C[P + 1], o, 2763975236); V = D(V, Y, X, W, C[P + 4], m, 1272893353); W = D(W, V, Y, X, C[P + 7], l, 4139469664); X = D(X, W, V, Y, C[P + 10], j, 3200236656); Y = D(Y, X, W, V, C[P + 13], o, 681279174); V = D(V, Y, X, W, C[P + 0], m, 3936430074); W = D(W, V, Y, X, C[P + 3], l, 3572445317); X = D(X, W, V, Y, C[P + 6], j, 76029189); Y = D(Y, X, W, V, C[P + 9], o, 3654602809); V = D(V, Y, X, W, C[P + 12], m, 3873151461); W = D(W, V, Y, X, C[P + 15], l, 530742520); X = D(X, W, V, Y, C[P + 2], j, 3299628645); Y = t(Y, X, W, V, C[P + 0], U, 4096336452); V = t(V, Y, X, W, C[P + 7], T, 1126891415); W = t(W, V, Y, X, C[P + 14], R, 2878612391); X = t(X, W, V, Y, C[P + 5], O, 4237533241); Y = t(Y, X, W, V, C[P + 12], U, 1700485571); V = t(V, Y, X, W, C[P + 3], T, 2399980690); W = t(W, V, Y, X, C[P + 10], R, 4293915773); X = t(X, W, V, Y, C[P + 1], O, 2240044497); Y = t(Y, X, W, V, C[P + 8], U, 1873313359); V = t(V, Y, X, W, C[P + 15], T, 4264355552); W = t(W, V, Y, X, C[P + 6], R, 2734768916); X = t(X, W, V, Y, C[P + 13], O, 1309151649); Y = t(Y, X, W, V, C[P + 4], U, 4149444226); V = t(V, Y, X, W, C[P + 11], T, 3174756917); W = t(W, V, Y, X, C[P + 2], R, 718787259); X = t(X, W, V, Y, C[P + 9], O, 3951481745); Y = K(Y, h); X = K(X, E); W = K(W, v); V = K(V, g) } var i = B(Y) + B(X) + B(W) + B(V); return i.toLowerCase() };


    function addToDatalayer(data) {
        if (typeof window.dataLayer[0].version == 'undefined') {
            //send page event
            window.dataLayer.push(data);
            //remove last
            window.dataLayer.splice(window.dataLayer.length - 1, 1);
            //insert first
            window.dataLayer.splice(0, 0, data);  
        }
        else {
            //send page event
            window.dataLayer.push(data);
            //remove last
            window.dataLayer.splice(window.dataLayer.length - 1, 1);
            //insert first
            window.dataLayer.splice(1, 0, data);
        }
    }


    //jquery for action triggered datalayer events
    $(document).on("click", "#i-filters-row .c-filter", function () {

        try {
            var text = $(this).text().trim();

            var data = {
                label: text,
                type: 'clic',
                pageType: 'ResultsVols',
                action: 'CTA',
                event: 'Filter'
            };

            console.log(data);

            addToDatalayer(data);


        }
        catch (ex) {
            console.log(ex.message);
            window.trackingError = ex.message;
        }

    });

    $(document).on("change", ".c-pop-filter li input[type=checkbox]", function () {

        try {
        var text = $(this).parent().find("label").text().trim();
        var label = $(".c-filter.c-act").text().trim();

        var data = {
            label: label,
            type: 'Selection',
            pageType: 'ResultsVols',
            action: text,
            event: 'Filter'
        };

            console.log(data);

            addToDatalayer(data);
        }
        catch (ex) {
            console.log(ex.message);
            window.trackingError = ex.message;
        }
    });

    $(document).on("click", ".c-pop-filter .c-ul-tick li", function () {
        try {
            var text = $(this).data("text").trim();

            var data = {
                label: "Escales",
                type: 'Selection',
                pageType: 'ResultsVols',
                action: text,
                event: 'Filter'
            };

            console.log(data);

            addToDatalayer(data);
        }
        catch (ex) {
            console.log(ex.message);
            window.trackingError = ex.message;
        }
    });

    $(document).on("click", "#i-filter-prices-pop .c-closer", function () {
        try {
            var text = $("#i-filter-prices-pop .c-slider-input").val();

            var data = {
                label: "Prix",
                type: 'Selection',
                pageType: 'ResultsVols',
                action: text,
                event: 'Filter'
            };

            console.log(data);

            addToDatalayer(data);
        }
        catch (ex) {
            console.log(ex.message);
            window.trackingError = ex.message;
        }
    });

    $(document).on("click", "#i-filter-times-pop .c-closer", function () {

        try {
            var min = $("#i-filter-times-pop .c-slider-input[name=my-slider-a]").val();
            var max = $("#i-filter-times-pop .c-slider-input[name=my-slider-b]").val();

            var data = {
                label: "Horaires",
                type: 'Selection',
                pageType: 'ResultsVols',
                action: min + " - " + max,
                event: 'Filter'
            };

            console.log(data);

            addToDatalayer(data);
        }
        catch (ex) {
            console.log(ex.message);
            window.trackingError = ex.message;
        }
    });

    $(document).on("click", "#i-sort-text", function () {

        try {
            var data = {
                label: 'Tri',
                type: 'clic',
                pageType: 'ResultsVols',
                action:'CTA',
                event: 'Tri'
            };

            console.log(data);

            addToDatalayer(data);
        }
        catch (ex) {
            console.log(ex.message);
            window.trackingError = ex.message;
        }
    });

    $(document).on("click", "#i-sort-pop li", function () {

        try {

            var text = $(this).text().trim();

            var data = {
                label: 'Tri',
                type: 'Selection',
                pageType: 'ResultsVols',
                action: text,
                event: 'Tri'
            };

            console.log(data);

            addToDatalayer(data);
        }
        catch (ex) {
            console.log(ex.message);
            window.trackingError = ex.message;
        }
    });

    $(document).on("selected", ".c-flight-in", function () {

        try {
            var origin = $window.$scope.requestSummary.origin;
            var dest = $window.$scope.requestSummary.destination;

            var company = $(this).find(".c-airline span").text();
            var price = $(this).find(".price-wrapper div").text();

            console.log(price);

            var data = {
                label: origin.cityName + " - " + dest.cityName,
                type: 'Selection',
                pageType: 'ResultsVols',
                action: 'outBound',
                destination: dest.countryName + " - NA - " + dest.cityName,
                productCodeDevis: company,
                event: 'Vol'
            };

            console.log(data);

           addToDatalayer(data);
        }
        catch (ex) {
            console.log(ex.message);
            window.trackingError = ex.message;
        }
    });

    $(document).on("click", ".c-clic", function (e) {

        try {

            var origin = $window.$scope.requestSummary.origin;
            var dest = $window.$scope.requestSummary.destination;

            var company = $(this).parent().find(".c-airline span").text();

            var data = {
                label: origin.cityName + " - " + dest.cityName,
                type: 'Selection',
                pageType: 'ResultsVols',
                action: 'inBound',
                destination: origin.countryName + " - NA - " + origin.cityName,
                productCodeDevis: company,
                event: 'Vol'
            };

            console.log(data);

            addToDatalayer(data);
        }
        catch (ex) {
            console.log(ex.message);
            window.trackingError = ex.message;
        }
    });

    $(document).on("click", ".c-recap .c-edit", function () {

        try {

            var data = {
                label: 'Modifier',
                type: 'clic',
                pageType: 'ResultsVols',
                action: 'CTA',
                event: 'Moteur'
            };

            console.log(data);

            addToDatalayer(data);
        }
        catch (ex) {
            console.log(ex.message);
            window.trackingError = ex.message;
        }
    });

    $(document).on("click", "#i-search-vols #i-search-btn", function () {

        try {

            var goDate = $("input[name=goDate]").val();
            var returnDate = $("input[name=returnDate]").val();
            var nbText = $("#i-travellers-text").text();
            var roundTripLabel = $("#searchType-text").text();
            var categoryVolLabel = $("#cabinClass-text").text();

            var regexPar = new RegExp('^([^(]+)\\s?\\([^)]+\\)\\s?\\(([^)]+)\\)$');
            var regexComa = new RegExp('^([^,]+)\\s?,\\s?([^,]+)$');
            var regexUnderscore = new RegExp('^[^_\s]+');

            var origin = $("#i-where-origin").val();
            var hidOrigin = $('input[name=origin]').val();
            var originCode = regexUnderscore.exec(hidOrigin)[0];
            var originName = '';

            if (regexPar.test(origin)) {
                originName = regexPar.exec(origin)[1].trim();
            }
            else {
                originName = regexComa.exec(origin)[2].trim();
            }

            var destination = $("#i-where-destination").val();

            var hidDestination = $('input[name=destination]').val();
            var destinationCode = regexUnderscore.exec(hidDestination)[0];
            var destinationName = '';

            if (regexPar.test(origin)) {
                destinationName = regexPar.exec(destination)[1].trim();
            }
            else {
                destinationName = regexComa.exec(destination)[2].trim();
            }


            var regexInt = new RegExp('\\d+', 'g');

            var matches = nbText.match(regexInt);
            var paxTotalVol = 0;

            for (i = 0; i < matches.length; i++) {
                paxTotalVol += parseInt(matches[i]);
            }

            var roundTrip = "NA";
            if (roundTripLabel == "aller-retour") {
                roundTrip = "AR"
            }
            if (roundTripLabel == "aller simple") {
                roundTrip = "oneway"
            }
            if (roundTripLabel == "multi-destinations") {
                roundTrip = "multi"
            }

            var categoryVol = "NA";
            if (categoryVolLabel == "économique") {
                categoryVol = "economic"
            }
            if (categoryVolLabel == "eco premium") {
                categoryVol = "ecoPremium"
            }
            if (categoryVolLabel == "affaire") {
                categoryVol = "business"
            }
            if (categoryVolLabel == "première") {
                categoryVol = "first"
            }

            var data = {
                label: 'Rechercher',
                type: 'clic',
                pageType: 'ResultsVols',
                action: 'Refine',
                departureDateVol: goDate,
                paxTotalVol: paxTotalVol,
                roundTrip: roundTrip,
                arrivalCityNameVol: destinationName,
                departureCityNameVol: originName,
                returnDateVol: returnDate,
                arrivalCityCodeVol: destinationCode,
                departureCityCodeVol: originCode,
                categoryVol: categoryVol,
                productCodeDevis: "NA",
                event: 'Vol'
            };

            console.log(data);

            addToDatalayer(data);
        }
        catch (ex) {
            console.log(ex.message);
            window.trackingError = ex.message;
        }
    });


    /* 
        Replace enum values by names: F => first, C => business, S => ecoPremium, Y => economic
    */
    function getClass(value) {

        console.log(value);

        var classe = 'economic';
        switch (value) {
            case 'F': classe = 'first'; break;
            case 'C': classe = 'business'; break;
            case 'S': classe = 'ecoPremium'; break;
            case 'Y': classe = 'economic'; break;
        }
        return classe;
    }

    /*
        Number of days between 2 dates
    */
    function daysBetween(date1, date2) {
        //Get 1 day in milliseconds
        var one_day = 1000 * 60 * 60 * 24;
        var d1 = new Date(date1.substring(6, 10), date1.substring(3, 5), date1.substring(0, 2));
        var d2 = new Date(date2.substring(6, 10), date2.substring(3, 5), date2.substring(0, 2));

        // Convert both dates to milliseconds
        var date1_ms = d1.getTime();
        var date2_ms = d2.getTime();

        // Calculate the difference in milliseconds
        var difference_ms = date2_ms - date1_ms;

        // Convert back to days and return
        return Math.round(difference_ms / one_day);
    }

    /*
        Loop over itineraries to concatenate companies separated by |
    */
    function getCompanies(itineraries) {

        var companies = '';

        angular.forEach(itineraries, function (itinerary, key) {
            companies += itinerary.marketingCarrier.name + " | ";
        });

        return companies.replace(/\s\|\s$/, "");
    }

    /*
       Loop over itineraries to concatenate cities separated by -
    */
    function getCities(itineraries) {

        var cities = '';

        angular.forEach(itineraries, function (itinerary, key) {
            cities += itinerary.origin.cityName + "-";
            cities += itinerary.destination.cityName + "-";
        });

        return cities.replace(/\-$/, "");
    }

    /*
        Loop over itineraries to compute the amount of stops
    */
    function getNbStops(itineraries) {

        var stops = 0;

        angular.forEach(itineraries, function (itinerary, key) {
            stops += itinerary.stops;
        });

        return stops;
    }

    /*
        Loop over itineraries to compute the total journey duration
        Also compares each flight countries to know if we remain in the same one
    */
    function getFlightType(itineraries) {

        var type = "NA";
        var duration = scopeParser.getFlightTimeInHours();
        var durationLimit = 4; //limit beetwen MC and LC => 4 hours
        var domestic = true;
        var lastCountry = null;

        angular.forEach(itineraries, function (itinerary, key) {
            if (domestic) {
                if (lastCountry != null && lastCountry != itinerary.origin.countryName) {
                    domestic = false;
                }
                lastCountry = itinerary.origin.countryName;
                if (lastCountry != null && lastCountry != itinerary.destination.countryName) {
                    domestic = false;
                }
                lastCountry = itinerary.destination.countryName;
            }
        });

        if (domestic) {
            type = "Domestique";
        }
        else if (duration < durationLimit) {
            type = "MC"
        }
        else {
            type = "LC"
        }

        return type;
    }

    /*
       Loop over fares to compute the tax amount
    */
    function getTotalTax(fares) {

        var tax = 0;

        angular.forEach(fares, function (fare, key) {

            tax += fare.totalTax.value;
        });

        return tax;
    }

    /*
       Loop over fares to compute the tax excluded price
    */
    function getTotalPriceHT(fares) {

        var price = 0;

        angular.forEach(fares, function (fare, key) {

            price += fare.totalAmount.value;
        });

        return price;
    }


    gtmProduct.prototype.set = function (name, value) {

        this[name] = value;
    }

    /*
        Stores and format a date from dd/MM/yyyy to yyyyMMdd
    */
    gtmProduct.prototype.setDate = function (name, value) {

        this[name] = value.substring(6, 10) + value.substring(3, 5) + value.substring(0, 2);
    }

    gtmProduct.prototype.setMonth = function (name, value) {

        this[name] = value.substring(6, 10) + value.substring(3, 5);
    }

    /*
        Build a product from a requestSummary
    */
    gtmProduct.parseRequest = function (r) {

        var isMulti = r.multiDestination;
        var lastIti = r.itineraries[r.itineraries.length - 1];
        var lastDate = isMulti ? lastIti.goDate : r.goDate2;
        var o = r.origin;
        var d = isMulti ? lastIti.destination : r.destination;
        var variant = isMulti ? 'multi' : r.oneWay ? 'oneway' : 'AR';

        var p = new gtmProduct();

        var dest = d.countryName + "-NA-" + d.cityName;

        p.set("departureDateVol", r.goDate.dateString);
        p.setMonth('monthVol', r.goDate.dateString);
        p.set("roundTrip", variant);
        p.set("paxAdultVol", r.adults);
        p.set("paxChildVol", r.childs);
        p.set("paxInfantVol", r.infants);
        p.set("paxTotalVol", r.adults + r.childs + r.infants);
        p.set("Email", "NA"); //replaced in parseScope

        p.set("contentGroup1", "Vol");
        p.set("contentGroup2", "NA");
        p.set("contentGroup3", dest + " & " + d.cityName + " & " + o.cityName);
        p.set("contentGroup4", "NA"); //company
        p.setMonth('contentGroup5', r.goDate.dateString);

        p.set("countryCodeVol", d.countryISO);
        p.set("countryNameVol", d.countryName);
        var flightTime = scopeParser.getFlightTimeInHours();
        if (flightTime > 0) {
            p.set("durationVol", flightTime);
        }
        else {
            p.set("durationVol", "NA");
        }
        p.set("numberEscale", "NA"); //replaced in parseScope
        p.set('productNameVol', getCities(r.itineraries));
        p.set("event", "ResultsVols");

        p.set("arrivalCityCodeVol", d.cityIATA);
        p.set("arrivalCityNameVol", d.cityName);
        p.set("departureCityCodeVol", o.cityIATA);
        p.set("departureCityNameVol", o.cityName);

        p.set("company", "NA"); //replaced in parseScope
        p.set("distance", "NA"); //replaced in parseScope
        p.set("version", isMobile ? "Mobile" : "Desktop"); //global var declared in master page

        p.set("pageId", "ResultsVols");

        p.set("destination", dest); 
        p.set("errorMessage", "NA");
        p.set("errorCode", "NA");
        p.set('categoryVol', getClass(r.cabinClass));

        if (!r.oneWay) { // no return date in one way
            p.set("returnDateVol", lastDate.dateString);
        }
        else {
            p.set("returnDateVol", "NA");
        }

        p.set("assurancesVol", "NA");
        p.set("nbrResultsVol", "NA");

        p.set("priceOutboundFlight", "NA");
        p.set("priceInboundFlight", "NA");
        p.set("priceTotalFlight", "NA");
        p.set("includedLugage", "NA");
        p.set("priceTax", "NA");
        p.set("priceTotalFlightHT", "NA");
        p.set("coupon", "NA");

        return p;
    }

    /*
        Not asked by ThomasCook, but called in controllers
    */
    gtmProduct.parseFlexy = function (proposal) {
        var p = new gtmProduct();
        return p;
    }

    /*
        Not asked by ThomasCook, but called in controllers
    */
    gtmProduct.parseBaggage = function (price) {
        var p = new gtmProduct();
        return p;
    }

    gtmProduct.parseInsurance = function (insurance) {

        var p = new gtmProduct();

        var ins = null

        if (insurance.isAnnul.quantity) {
            ins = "annulation";
        }
        else if (insurance.isAnnulRepatriament.quantity) {
            ins = "multi"
        }
        else if (insurance.isRepatriament.quantity) {
            ins = "multi"
        }

        p.set('assurancesVol', ins);
        return p;
    }

    /*
        This method has been added for partners to get every data from scope and to store it in new product object
    */
    gtmProduct.parseScope = function (scope) {
        var p = new gtmProduct();
        //since this method is called everywhere, carefully test if level
        if (scope.bkgData) {

            if (scope.bkgData.insurancesSelected && scope.bkgData.insurancesSelected.isAnnul) {
                var ins = null
                if (scope.bkgData.insurancesSelected.isAnnul.quantity) {
                    ins = "annulation";
                }
                else if (scope.bkgData.insurancesSelected.isAnnulRepatriament.quantity) {
                    ins = "multi"
                }
                else if (scope.bkgData.insurancesSelected.isRepatriament.quantity) {
                    ins = "multi"
                }
                p.set('assurancesVol', ins);
            }

            if(scope.bkgData.bookingRequest) {
                if(scope.bkgData.bookingRequest.contact && scope.bkgData.bookingRequest.contact.mail) {
                    p.set("Email", MD5(scope.bkgData.bookingRequest.contact.mail));
                }
                if(scope.bkgData.bookingRequest.discountCode) {
                    p.set("coupon", scope.bkgData.bookingRequest.discountCode);
                }
            }


            if(scope.bkgData.bookingResponse) {
                p.set("bookingId", scope.bkgData.bookingResponse.numbers[0].bookingNumber);
            }

            if (scope.bkgData.purchaseResponse) {
                if (scope.bkgData.purchaseResponse.itineraries) {
                    var companies = getCompanies(scope.bkgData.purchaseResponse.itineraries);
                    var stops = getNbStops(scope.bkgData.purchaseResponse.itineraries);
                    var type = getFlightType(scope.bkgData.purchaseResponse.itineraries);
                    p.set("company", companies);
                    p.set("contentGroup4", companies);
                    p.set("numberEscale", stops);
                    p.set("distance", type);
                }

                if (scope.bkgData.purchaseResponse.proposalsRequested && scope.bkgData.purchaseResponse.proposalsRequested.fares) {

                    console.log("totalTax");

                    var includedLugage = scope.bkgData.purchaseResponse.proposalsRequested.fareWithLugage;
                    var totalTax = getTotalTax(scope.bkgData.purchaseResponse.proposalsRequested.fares);
                    //var totalPriceHT = getTotalPriceHT(scope.bkgData.purchaseResponse.proposalsRequested.fares);
                    p.set("includedLugage", includedLugage);
                    p.set("priceTax", totalTax);
                    //p.set("priceTotalFlightHT", totalPriceHT);

                    //compute price in case insurances and luggage have been added
                    if (scope.bkgData.prixTotal) {

                        console.log("scope.bkgData.prixTotal");

                        totalPriceHT = scope.bkgData.prixTotal.value - totalTax;
                        p.set("priceTotalFlightHT", totalPriceHT);
                        p.set('priceTotalFlight', scope.bkgData.prixTotal.value);
                    }
                }
            }
            
        }
        if (scope.rawResults && scope.rawResults.products) {
            p.set("nbrResultsVol", scope.rawResults.products.length);
            p.set("contentGroup2", "Results");
        }
        if (window.location.pathname.startsWith('/airbooking/')) {
            var step = $location.hash() != "" ? $location.hash() : "1";
            p.set("contentGroup2", "TunnelStep" + step);

        }

        return p;
    }

    /*
        Not asked by ThomasCook, but called in controllers
    */
    gtmProduct.prototype.applyFilter = function (view) {
        return this;
    }

    gtmProduct.prototype.applyPrice = function (price) {

        var totalTax = getTotalTax($window.$scope.bkgData.purchaseResponse.proposalsRequested.fares);

        this.set("priceTotalFlightHT", price.value - totalTax);

        this.set('event', 'TunnelVol');
        this.set('pageId', 'TunnelVol');
        this.set('priceTotalFlight', price.value);
        return this;
    }

    return gtmProduct;

}]);
